import React from 'react';
import styles from './TemplatesPreview.module.scss';
import ElementPhone from './Group/ElementPhone';
import ElementUrl from './Group/ElementUrl';
import ElementEmail from './Group/ElementEmail';
import ElementAddress from './Group/ElemaentAddress';
import { registrationTypes } from '../../../constants/registrationTypes';

const TemplatesPreview = ({ stateForm, registrationTypeHouse, blocks }) => {
  function isObjectEmpty(obj) {
    return Object.values(obj).every((value) => {
      return (
        value === undefined ||
        value === null ||
        value === '' ||
        (Array.isArray(value) && value.length === 0) ||
        (typeof value === 'object' && Object.keys(value).length === 0)
      );
    });
  }

  const paragraphs = (overBlocksForm) => {
    return overBlocksForm?.message.split('\n').map((line, index) => (
      <p
        className={styles.message}
        key={index}
      >
        {line}
      </p>
    ));
  };

  return (
    <>
      {isObjectEmpty(stateForm) &&
      isObjectEmpty(blocks.block1) &&
      isObjectEmpty(blocks.block2) ? (
        <div className={styles.previewNone}>
          Начните заполнять форму и тут появится ваше сообщение
        </div>
      ) : registrationTypeHouse?.id ===
        registrationTypes.personalAccounts.id ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <div className={styles.countBlock}>1 блок:</div>
          <div className={styles.preview}>
            {blocks.block1?.title && <h3>{blocks.block1?.title}</h3>}
            <div className={styles.paragraphs}>{paragraphs(blocks.block1)}</div>
            {(blocks.block1?.phone ||
              blocks.block1?.url ||
              blocks.block1?.email ||
              blocks.block1?.address) && (
              <div className={styles.group}>
                {blocks.block1?.phone && (
                  <ElementPhone value={blocks.block1?.phone} />
                )}
                {blocks.block1?.url && (
                  <ElementUrl
                    type="url"
                    value={blocks.block1?.url}
                  />
                )}
                {blocks.block1?.email && (
                  <ElementEmail
                    type="email"
                    value={blocks.block1?.email}
                  />
                )}
                {blocks.block1?.address && (
                  <ElementAddress
                    type="address"
                    value={blocks.block1?.address}
                  />
                )}
              </div>
            )}
          </div>
          <div className={styles.countBlock}>2 блок:</div>
          <div className={styles.dopBlock}>
            Автоматический текст.
            <br />
            Из выбранных вами лицевых счетов мы покажем здесь доступные
            собственнику для регистрации (те, которые имеются у него в ЖФ)
            Пример:
            <br />
            {/* ЖКХ (УК "Одуванчики"), Домофон (Авентин, ООО "Домофончики") */}
            ЖКХ, Домофон
          </div>
          {!isObjectEmpty(blocks.block2) && (
            <>
              <div className={styles.countBlock}>3 блок:</div>
              <div className={styles.preview}>
                <div className={styles.paragraphs}>
                  {paragraphs(blocks.block2)}
                </div>
                {(blocks.block2?.phone ||
                  blocks.block2?.url ||
                  blocks.block2?.email ||
                  blocks.block2?.address) && (
                  <div className={styles.group}>
                    {blocks.block2?.phone && (
                      <ElementPhone value={blocks.block2?.phone} />
                    )}
                    {blocks.block2?.url && (
                      <ElementUrl
                        type="url"
                        value={blocks.block2?.url}
                      />
                    )}
                    {blocks.block2?.email && (
                      <ElementEmail
                        type="email"
                        value={blocks.block2?.email}
                      />
                    )}
                    {blocks.block2?.address && (
                      <ElementAddress
                        type="address"
                        value={blocks.block2?.address}
                      />
                    )}
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      ) : (
        <div className={styles.preview}>
          {stateForm?.title && <h3>{stateForm?.title}</h3>}
          <div className={styles.paragraphs}>{paragraphs(stateForm)}</div>
          {(stateForm?.phone ||
            stateForm?.url ||
            stateForm?.email ||
            stateForm?.address) && (
            <div className={styles.group}>
              {stateForm?.phone && <ElementPhone value={stateForm?.phone} />}
              {stateForm?.url && (
                <ElementUrl
                  type="url"
                  value={stateForm?.url}
                />
              )}
              {stateForm?.email && (
                <ElementEmail
                  type="email"
                  value={stateForm?.email}
                />
              )}
              {stateForm?.address && (
                <ElementAddress
                  type="address"
                  value={stateForm?.address}
                />
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default TemplatesPreview;
